const initialState = {
  progress: 0,
  total: 0
};

export default function reducer(state=initialState, action) {
  switch(action.type) {
    case 'ADVANCE':
      return {...state, progress: Math.min(state.progress + 1, state.total)};
    case 'REVERT':
      return {...state, progress: Math.max(state.progress - 1, 0)};
    case 'SET_TOTAL':
      return {...state, total: action.payload};
    default:
      return {...state}
  }
}


// WEBPACK FOOTER //
// ./src/reducers/progress.js